import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

/**
 * Material Design (MUI) dropdown menu with a 3-dots trigger.
 * Items are text-only actions; the menu closes on selection or outside click.
 *
 * `menuZIndex` sube el menu por encima del overlay. Hace falta cuando el menu se
 * abre dentro de un modal de la plataforma, cuyo overlay usa z-index 9999 y
 * dejaria el menu (portado al body) detras.
 */
export function ActionsMenu({ items = [], title = 'Acciones', menuZIndex }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (e) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => setAnchorEl(null);

    return (
        <>
            <IconButton
                size="small"
                aria-label={title}
                title={title}
                onClick={handleOpen}
                sx={{
                    color: 'rgba(var(--ink-overlay-rgb),0.65)',
                    '&:hover': { backgroundColor: 'rgba(var(--ink-overlay-rgb),0.08)', color: 'var(--ink-text)' },
                }}
            >
                <MoreVertIcon fontSize="small" />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={(e) => e.stopPropagation()}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                slotProps={{
                    // El root es el div position:fixed que monta el portal; es el
                    // que compite en z-index con el overlay del modal, no el <ul>.
                    ...(menuZIndex ? { root: { sx: { zIndex: menuZIndex } } } : {}),
                    paper: {
                        sx: {
                            backgroundColor: 'var(--ink-surface-raised)',
                            backgroundImage: 'none',
                            border: '1px solid rgba(var(--ink-overlay-rgb),0.12)',
                            borderRadius: '12px',
                            boxShadow: '0 10px 30px rgba(0,0,0,0.35)',
                            mt: 0.5,
                        },
                    },
                }}
            >
                {items.map((item, i) => (
                    <MenuItem
                        key={i}
                        disabled={!!item.disabled}
                        title={item.title || undefined}
                        onClick={() => {
                            if (item.disabled) return;
                            handleClose();
                            if (item.onClick) item.onClick();
                        }}
                        sx={{
                            fontSize: '0.85rem',
                            minHeight: 40,
                            color: item.danger ? '#f87171' : 'rgba(var(--ink-overlay-rgb),0.85)',
                            '&:hover': {
                                backgroundColor: item.danger ? 'rgba(248,113,113,0.12)' : 'rgba(var(--ink-overlay-rgb),0.08)',
                            },
                            '&.Mui-disabled': {
                                color: 'rgba(var(--ink-overlay-rgb),0.35)',
                            },
                        }}
                    >
                        {item.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}

export default ActionsMenu;